import { useLocation } from 'react-router-dom';
import { useMemo } from 'react';

/**
 * This hook might be used to read parameters from the URL's query string.
 *
 * @example const { sort } = useQueryParams();
 */
const useQueryParams = (): Record<string, string> => {
  const { search } = useLocation();
  return useMemo(() => Object.fromEntries(new URLSearchParams(search).entries()), [search]);
};

export default useQueryParams;
